// extracted by mini-css-extract-plugin
module.exports = {"image":"PlayfulPreviewImage_image__VMo33"};